import React from 'react';

import type { WProjectCustomizationElementView } from '@zola/svc-web-api-ts-client';
import { TextElement } from './TextElement';
import { ImageElement } from './ImageElement';
import { isImageElementView, isTextElementView } from '../../types/ElementView';
import { Bleed } from '../../util/getCardBleed';

interface CustomizationElementProps {
  element: WProjectCustomizationElementView;
  bleed: Bleed;
  foilColor?: string;
  isPlaceCard?: boolean;
  isBoundingBoxAdjusted: boolean;
  scale?: number; // Used only to limit fetched asset dimensions
}

export const CustomizationElement: React.FC<CustomizationElementProps> = ({
  element,
  bleed,
  foilColor,
  isPlaceCard,
  isBoundingBoxAdjusted,
  scale,
}) => {
  if (typeof window === 'undefined') return null;

  if (isImageElementView(element)) {
    return <ImageElement foilColor={foilColor} element={element} bleed={bleed} scale={scale} />;
  }
  if (isTextElementView(element)) {
    return (
      <TextElement
        element={element}
        bleed={bleed}
        foilColor={foilColor}
        isPlaceCard={isPlaceCard}
        isBoundingBoxAdjusted={isBoundingBoxAdjusted}
      />
    );
  }
  return null;
};
